import { countries } from 'data';

export const getCountryName = (code: string) => countries.find((c) => c.code === code)?.name;
